var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.993,
    height: 15.477,
    viewBox: "0 0 18.993 15.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11360",
    "data-name": "Path 11360",
    d: "M-1465.217-1776.017a7.969,7.969,0,0,0,5.713-1.606,4.026,4.026,0,0,1-3.639-2.725,4.46,4.46,0,0,0,1.724-.071,3.907,3.907,0,0,1-3.056-3.87,3.923,3.923,0,0,0,1.723.458,3.914,3.914,0,0,1-1.685-2.766,3.8,3.8,0,0,1,.5-2.431,11.124,11.124,0,0,0,8.016,4.075c-.014-.393-.047-.763-.037-1.132a3.892,3.892,0,0,1,2.822-3.518,3.848,3.848,0,0,1,3.81.985.249.249,0,0,0,.263.065,7.863,7.863,0,0,0,2.146-.814c.043-.024.088-.043.161-.078a3.027,3.027,0,0,1-.629,1.187c-.291.331-.625.624-.934.927a7.844,7.844,0,0,0,2.051-.564l.042.046c-.314.368-.611.75-.946,1.1-.27.28-.589.512-.877.775a.349.349,0,0,0-.106.23,11.225,11.225,0,0,1-4.865,9.615,10.068,10.068,0,0,1-4.667,1.756,11.485,11.485,0,0,1-4.714-.343,10.714,10.714,0,0,1-2.737-1.229A1.028,1.028,0,0,1-1465.217-1776.017Z",
    transform: "translate(1465.217 1789.751)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.378dcf94724c8d11e04127278ad7dd16.svg";
export { ForwardRef as ReactComponent };